import http from '../common/http';
import { SignupRequestAttributes } from '../types/auth';
import { AxiosResponse } from 'axios';

export interface ChangePasswordRequestPayload {
  oldPassword: string;
  newPassword: string;
}
class AuthService {
  refresh(token: string) {
    return http.post('/auth/refresh', { refreshToken: token });
  }

  login(email: string, password: string) {
    return http.post('/auth/login', { email, password });
  }

  signup(data: SignupRequestAttributes) {
    return http.post('/auth/register', data);
  }

  signupConfirm(email: string, code: string) {
    return http.post('/auth/confirm', { email, code });
  }

  resendCode(email: string) {
    return http.post('/auth/resend-code', { email });
  }

  recovery(email: string) {
    return http.post('/auth/recovery', { email });
  }

  recoveryConfirm(token: string, password: string) {
    return http.post('/auth/recovery-confirm', { token, password });
  }

  inviteConfirm(token: string, password: string) {
    return http.post('/invites/confirm', { token, password });
  }

  changePassword(data: ChangePasswordRequestPayload): Promise<AxiosResponse> {
    return http.post('/auth/change-password', data);
  }
}

export default new AuthService();
